export default __webpack_public_path__ + "static/media/C0000.bf88d5b2.png";